import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {MenuItem, TextField, Typography} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import {I18nContext} from 'contexts/i18n';
import {getColor} from 'utils/common';

const withItemStyles = withStyles(({palette}) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    '&>*': {
      marginRight: 5,
    },
  },
  label: {
    color: getColor({
      palette,
      lightModeColor: palette.common.black,
      darkModeColor: palette.common.white,
    }),
  },
}));

const ItemsPerPageSelector = withItemStyles(({value, onChange, component: Component, classes, ...restProps}) => {
  const {i18nTranslate} = useContext(I18nContext);

  return (
    <Component className={classes.root} {...restProps}>
      <Typography noWrap className={classes.label}>{i18nTranslate`Show:`}</Typography>
      <TextField select value={value} onChange={onChange}>
        {[10, 20, 50, 100].map((value) => (
          <MenuItem key={value} value={value}>
            {value + i18nTranslate` items`}
          </MenuItem>
        ))}
      </TextField>
    </Component>
  );
});

ItemsPerPageSelector.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  component: PropTypes.any.isRequired,
};

export default ItemsPerPageSelector;
